
    import './styles.scoped.css';
    export default {
  "root": "_root_49kgp_3",
  "layout-wrapper": "_layout-wrapper_49kgp_4",
  "close-button": "_close-button_49kgp_9",
  "layout": "_layout_49kgp_4",
  "layout-no-scroll": "_layout-no-scroll_49kgp_22",
  "layout-main": "_layout-main_49kgp_26",
  "layout-main-scrollable": "_layout-main-scrollable_49kgp_31",
  "drawer": "_drawer_49kgp_35",
  "drawer-mobile": "_drawer-mobile_49kgp_41",
  "drawer-closed": "_drawer-closed_49kgp_44",
  "drawer-content": "_drawer-content_49kgp_55",
  "toggle": "_toggle_49kgp_74",
  "breadcrumbs-desktop": "_breadcrumbs-desktop_49kgp_79",
  "content-wrapper": "_content-wrapper_49kgp_83",
  "content-wrapper-mobile": "_content-wrapper-mobile_49kgp_86",
  "notifications-sticky": "_notifications-sticky_49kgp_94",
  "navigation": "_navigation_49kgp_100",
  "navigation-toggle": "_navigation-toggle_49kgp_104",
  "navigation-close": "_navigation-close_49kgp_108",
  "tools": "_tools_49kgp_112",
  "tools-toggle": "_tools-toggle_49kgp_116",
  "tools-close": "_tools-close_49kgp_120",
  "notifications": "_notifications_49kgp_94",
  "breadcrumbs": "_breadcrumbs_49kgp_79",
  "content": "_content_49kgp_83"
};
  